import * as React from 'react'
import { IStageInfo } from 'app/types'


export default class StageCounter extends React.PureComponent<{
  info: IStageInfo
}> {

  render() {
    const { current, total } = this.props.info

    const style: any = {
      position: 'absolute',
      top: 12,
      left: 12,
      fontSize: 30,
      cursor: 'default',
      userSelect: 'none'
    }

    return (
      <div style={style}>
        {total - current + 1}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/comp/stage-counter.tsx